import BaseSliderManager from "../../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";
import { SliderGenProps } from "../../../../../src/types/Interface";
import { eventBus, EnumEventBus } from "./EventBus";


const SliderGen: SliderGenProps[] = [
  {
    head: "move tangent point",
    colors: {
      bgColor: 0xB5A1FF,
      barColor: 0x000000,
      buttonColor: 0xB5A1FF
    },
    onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveTangentPoint, v - 100)
  },
  {
    head: "rotate triangle",
    colors: {
      bgColor: 0xBFBFBF,
      barColor: 0x000000,
      buttonColor: 0x000000
    },
    onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveAllPoints, v - 100)
  },
]



export default class SliderManager extends BaseSliderManager {
  constructor() {
    super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL)
  }
}